// This file was auto generated by resource-sync tools.

import ar_shop_set_web from './ar/shop_set_web.json';
import en_shop_set_web from './en/shop_set_web.json';
import zh_shop_set_web from './zh/shop_set_web.json';
import zhHK_shop_set_web from './zh-HK/shop_set_web.json';
import ar_finance_bankcardEdit from './ar/finance_bankcardEdit.json';
import en_finance_bankcardEdit from './en/finance_bankcardEdit.json';
import zh_finance_bankcardEdit from './zh/finance_bankcardEdit.json';
import zhHK_finance_bankcardEdit from './zh-HK/finance_bankcardEdit.json';
import ar_message_center from './ar/message_center.json';
import en_message_center from './en/message_center.json';
import zh_message_center from './zh/message_center.json';
import zhHK_message_center from './zh-HK/message_center.json';
import ar_Merchant_open_time_web_v1 from './ar/Merchant_open_time_web_v1.json';
import en_Merchant_open_time_web_v1 from './en/Merchant_open_time_web_v1.json';
import zh_Merchant_open_time_web_v1 from './zh/Merchant_open_time_web_v1.json';
import zhHK_Merchant_open_time_web_v1 from './zh-HK/Merchant_open_time_web_v1.json';
import ar_account_web from './ar/account_web.json';
import en_account_web from './en/account_web.json';
import zh_account_web from './zh/account_web.json';
import zhHK_account_web from './zh-HK/account_web.json';
import ar_business_status from './ar/business_status.json';
import en_business_status from './en/business_status.json';
import zh_business_status from './zh/business_status.json';
import zhHK_business_status from './zh-HK/business_status.json';
import ar_customer_review_web from './ar/customer_review_web.json';
import en_customer_review_web from './en/customer_review_web.json';
import zh_customer_review_web from './zh/customer_review_web.json';
import zhHK_customer_review_web from './zh-HK/customer_review_web.json';
import ar_Healthiness_level from './ar/Healthiness_level.json';
import en_Healthiness_level from './en/Healthiness_level.json';
import zh_Healthiness_level from './zh/Healthiness_level.json';
import zhHK_Healthiness_level from './zh-HK/Healthiness_level.json';
import ar_Native_BasicServices from './ar/Native_BasicServices.json';
import en_Native_BasicServices from './en/Native_BasicServices.json';
import zh_Native_BasicServices from './zh/Native_BasicServices.json';
import zhHK_Native_BasicServices from './zh-HK/Native_BasicServices.json';
import ar_B_APP from './ar/B_APP.json';
import en_B_APP from './en/B_APP.json';
import zh_B_APP from './zh/B_APP.json';
import zhHK_B_APP from './zh-HK/B_APP.json';
import ar_pos_order_process from './ar/pos_order_process.json';
import en_pos_order_process from './en/pos_order_process.json';
import zh_pos_order_process from './zh/pos_order_process.json';


const resources = {
    'ar': {
        shop_set_web: ar_shop_set_web,
        finance_bankcardEdit: ar_finance_bankcardEdit,
        message_center: ar_message_center,
        Merchant_open_time_web_v1: ar_Merchant_open_time_web_v1,
        account_web: ar_account_web,
        business_status: ar_business_status,
        customer_review_web: ar_customer_review_web,
        Healthiness_level: ar_Healthiness_level,
        Native_BasicServices: ar_Native_BasicServices,
        B_APP: ar_B_APP,
        pos_order_process: ar_pos_order_process
    },
    'en': {
        shop_set_web: en_shop_set_web,
        finance_bankcardEdit: en_finance_bankcardEdit,
        message_center: en_message_center,
        Merchant_open_time_web_v1: en_Merchant_open_time_web_v1,
        account_web: en_account_web,
        business_status: en_business_status,
        customer_review_web: en_customer_review_web,
        Healthiness_level: en_Healthiness_level,
        Native_BasicServices: en_Native_BasicServices,
        B_APP: en_B_APP,
        pos_order_process: en_pos_order_process
    },
    'zh': {
        shop_set_web: zh_shop_set_web,
        finance_bankcardEdit: zh_finance_bankcardEdit,
        message_center: zh_message_center,
        Merchant_open_time_web_v1: zh_Merchant_open_time_web_v1,
        account_web: zh_account_web,
        business_status: zh_business_status,
        customer_review_web: zh_customer_review_web,
        Healthiness_level: zh_Healthiness_level,
        Native_BasicServices: zh_Native_BasicServices,
        B_APP: zh_B_APP,
        pos_order_process: zh_pos_order_process
    },
    'zh-HK': {
        shop_set_web: zhHK_shop_set_web,
        finance_bankcardEdit: zhHK_finance_bankcardEdit,
        message_center: zhHK_message_center,
        Merchant_open_time_web_v1: zhHK_Merchant_open_time_web_v1,
        account_web: zhHK_account_web,
        business_status: zhHK_business_status,
        customer_review_web: zhHK_customer_review_web,
        Healthiness_level: zhHK_Healthiness_level,
        Native_BasicServices: zhHK_Native_BasicServices,
        B_APP: zhHK_B_APP,
    }
};

export default resources;